export interface IAuthReducer {
  isAuth: boolean | null
}
export const authInitialState:IAuthReducer = {
  isAuth: null
};
